import { useIntl } from "react-intl";
import { Dialog } from "../../../../common/core-ui/Dialog.tsx";
import styles from "./ConfirmOptOutDialog.module.scss";
import { ReactNode } from "react";

interface ConfirmOptOutDialogProps {
  title: string;
  subtitle: ReactNode;
  children: ReactNode;
  onRequestClose: () => void;
  onConfirmOptOut: () => void;
  isProcessing?: boolean;
}

function ConfirmOptOutInner({
  subtitle,
  children,
}: Pick<ConfirmOptOutDialogProps, "subtitle" | "children">) {
  return (
    <>
      <div className={styles.header}>
        <div className={styles.subtitle}>{subtitle}</div>
      </div>
      {children}
    </>
  );
}

export default function ConfirmOptOutDialog({
  title,
  subtitle,
  onConfirmOptOut,
  onRequestClose,
  children,
  isProcessing,
}: ConfirmOptOutDialogProps) {
  const intl = useIntl();

  return (
    <Dialog
      canClose={!isProcessing}
      title={title}
      onRequestClose={onRequestClose}
      primaryButton={{
        onClick: onConfirmOptOut,
        label: intl.formatMessage({ defaultMessage: "Confirm Opt Out" }),
        loading: isProcessing,
      }}
      secondaryButton={{
        onClick: onRequestClose,
        label: intl.formatMessage({ defaultMessage: "Cancel" }),
        disabled: isProcessing,
      }}
    >
      <ConfirmOptOutInner subtitle={subtitle}>{children}</ConfirmOptOutInner>
    </Dialog>
  );
}
